import { render, staticRenderFns } from "./ViewFile.vue?vue&type=template&id=6b90b56a&scoped=true&"
import script from "./ViewFile.vue?vue&type=script&lang=js&"
export * from "./ViewFile.vue?vue&type=script&lang=js&"
import style0 from "./ViewFile.vue?vue&type=style&index=0&id=6b90b56a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b90b56a",
  null
  
)

export default component.exports